export const WORK_DATA = [
   {
    id: "1",
    header: "Stock Analyzer with MCP",
    title: "MCP Server and Agents With Claude",
    description: [
      "Stock Analyzer with MCP, Gemini, and yFinance is a Python-based tool that lets users query and compare real-time stock prices using natural language.",
      "It combines yFinance for market data, Google Gemini for understanding user queries, and MCP (Model Context Protocol) to connect tools seamlessly."
    ],
    bgUrl:
      "",
    link: "https://github.com/pvyas033/stockanalyzer#readme",
    bgUrl: "https://github.com/pvyas033/host/blob/master/img/port9-min.jpg?raw=true",
    btnText: "Read More",
    videoUrl: "demo/stockana.mp4"
  },
  {
    id: "2",
    header: "ML Framework for linear regression",
    title: "ML Framework Python & Java",
    description: [
      "ML framework for performing ml operations on linear regression dataset",
      "User can train test and get the score of the model.",
    ],
    bgUrl:
      "https://github.com/pvyas033/host/blob/master/img/port1-min.jpg?raw=true",
    link: "https://pankajvyas.in/#/ml/lrmodel",
    btnText: "Read More",
  },
  {
    id: "3",
    header: "Kafka FluentD Newrelic",
    title: "Data Streaming",
    description: [
      "Transfer data seamlessly from Kafka to New Relic for enhanced analysis and insights.",
      "Streamline your data flow, ensuring efficient monitoring and analysis using New Relic's robust analytics platform.",
    ],
    bgUrl:
      "https://github.com/pvyas033/host/blob/master/img/port2-min.jpg?raw=true",
    link: "https://github.com/pvyas033/data_streaming#readme",
    btnText: "Read More",
  },
  {
    id: "4",
    header: "Microservices Architecture",
    title: "Event Logging",
    description: [
      "Event-driven microservices architecture with patterns ",
      "using Spring boot, Spring cloud, Kafka and Elasticsearch.",
    ],
    bgUrl:
      "https://github.com/pvyas033/host/blob/master/img/port3-min.jpg?raw=true",
    link: "https://github.com/pvyas033/event-driven-microservices#readme",
    btnText: "Read More",
  },
  {
    id: "5",
    header: "Interface",
    title: "Email Sender",
    description: [
      "REST API to send emails, user needs to provide",
      "excel file then it will extract emails and send",
    ],
    bgUrl:
      "https://github.com/pvyas033/host/blob/master/img/port4-min.jpg?raw=true",
    link: "https://github.com/pvyas033/email-sender#readme",
    btnText: "Read More",
  },
  {
    id: "6",
    header: "Online Clothing Store",
    title: "Door Store",
    description: [
      "In learning of React, I built the website, designed",
      "the structure, and created standout site experience",
    ],
    bgUrl:
      "https://github.com/pvyas033/host/blob/master/img/port5-min.jpg?raw=true",
    link: "https://pvyas033.github.io/crwn-clothing/#/",
    btnText: "Visit Site",
  },
  {
    id: "7",
    header: "Reporting",
    title: "Model To Report",
    description: [
      "Desktop Application that helps to create reports",
      "from reporting template and model data",
    ],
    bgUrl:
      "https://github.com/pvyas033/host/blob/master/img/port6-min.jpg?raw=true",
    link: "https://github.com/pvyas033/reporting-tool#readme",
    btnText: "Read More",
  }
];
